import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import httpClient from '../utils/httpClient';

const VideoJS = ({ videoId }) => {
  const [meta, setMeta] = React.useState({});
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);

  const options = {
    controls: true,
    width: 500,
    sources: [{
      src: meta.hlsUrl,
      type: 'application/x-mpegURL',
    }]
  }

  React.useEffect(() => {
    // Check if CloudFront signing is needed and cookies are available
    if (meta && meta.cookie) {
      let vhsXhr = null;
      // Prioritize global videojs.Vhs.xhr as confirmed working
      if (videojs.Vhs && videojs.Vhs.xhr) {
        vhsXhr = videojs.Vhs.xhr;
      } else if (videojs.vhs && videojs.vhs.xhr) {
        // Fallback to instance if global is not found
        vhsXhr = videojs.vhs.xhr;
      }

      if (vhsXhr) {
        // Clear any previous hook to avoid multiple registrations.
        vhsXhr.beforeRequest = undefined;
        vhsXhr.beforeRequest = (reqOptions) => {
          if (meta.cookie) {
            const policy = meta.cookie['CloudFront-Policy'];
            const keyPair = meta.cookie['CloudFront-Key-Pair-Id'];
            const signature = meta.cookie['CloudFront-Signature'];

            if (policy && keyPair && signature) {
              const params = `?Policy=${policy}&Key-Pair-Id=${keyPair}&Signature=${signature}`;
              reqOptions.uri = reqOptions.uri + params;
            } else {
              // Properties missing, do not add params
            }
          } else {
             // meta.cookie is falsy, do not add params
          }
          return reqOptions;
        };
      } else {
        // VHS XHR object not found, cannot set CloudFront headers.
        // Depending on requirements, an error could be thrown or logged to an error reporting service here.
      }
    } else {
      // Clear the hook if cookies are no longer present or CloudFront is not used
      if (videojs.Vhs && videojs.Vhs.xhr && videojs.Vhs.xhr.beforeRequest) {
        videojs.Vhs.xhr.beforeRequest = undefined;
      }
      // Also clear instance hook if it was used as a fallback
      if (videojs.vhs && videojs.vhs.xhr && videojs.vhs.xhr.beforeRequest) {
        videojs.vhs.xhr.beforeRequest = undefined;
      }
    }

    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) return;

      playerRef.current = videojs(videoElement, options);
    } else {
      const player = playerRef.current
      options.sources && player.src(options.sources)
    }
  }, [meta, options]);

  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  React.useEffect(() => {
    const apiUrl = process.env.REACT_APP_BACKEND_URL;
    httpClient(`${apiUrl}/skills/videos/${videoId}/metadata`).then(({ json }) => {
      setMeta(json);
    })
  }, [videoId]);

  return (
    <div data-vjs-player>
      <video ref={videoRef} className="video-js vjs-big-play-centered" />
    </div>
  );
}

export default VideoJS;
